<div class="pack-option">
  <div class="pack-option--header">
    <div *ngIf="!packOptionLogoUrl" class="pack-option--title" [translate]="orderOption.titleKey"></div>
    <img *ngIf="packOptionLogoUrl" class="pack-option--logo" src="{{packOptionLogoUrl}}"/>
  </div>
  <div class="pack-option--body">
    <div class="pack-option--body-container">
      <div class="pack-option--description-text ">
        <ul class="list-style--v2" [innerHTML]="orderOption.descriptionKey | translate"></ul>
      </div>
      <div class="pack-option--price">
        <div class="price-box">
          <div class="price">
            <span *ngIf="hasPromo && !hasDiscount" class="promo-original-price">
              <ng-container *ngIf="getCurrentLang !== 'fr'" class="currency">€</ng-container>
              <span>{{textIntegerPartOriginal}}{{textDecimalPartOriginal}}</span>
              <ng-container *ngIf="getCurrentLang === 'fr'" class="currency left">€</ng-container>
            </span>
            <div class="price-left">€</div>
            <div class="price-left"><span class="currency">{{textIntegerPart}}</span></div>
            <div class="price-right">
              <span class="comma">{{textDecimalPart}}</span>
              <div class="after">/<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="standalone-flavor-option--below-part bottom">
      <div>
        <app-order-button class="smallHeight" *ngIf="pack"
                          [x]="x"
                          [y]="y"
                          [pack]="pack"
                          [ownerComponent]="ownerComponent"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()"
                          [buttonTextKey]="'eos-tv-shop-ii.btn.pack-option-order'">
        </app-order-button>
      </div>
    </div>
  </div>
</div>
